"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseToJSON = exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSONTyped = exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSON = exports.instanceOfApiStoresUrlSlugAnalyticsProductsGet200Response = void 0;
var runtime_1 = require("../runtime");
var AnalyticsProductItem_1 = require("./AnalyticsProductItem");
/**
 * Check if a given object implements the ApiStoresUrlSlugAnalyticsProductsGet200Response interface.
 */
function instanceOfApiStoresUrlSlugAnalyticsProductsGet200Response(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfApiStoresUrlSlugAnalyticsProductsGet200Response = instanceOfApiStoresUrlSlugAnalyticsProductsGet200Response;
function ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSON(json) {
    return ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSONTyped(json, false);
}
exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSON = ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSON;
function ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'products': !(0, runtime_1.exists)(json, 'products') ? undefined : (json['products'].map(AnalyticsProductItem_1.AnalyticsProductItemFromJSON)),
    };
}
exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSONTyped = ApiStoresUrlSlugAnalyticsProductsGet200ResponseFromJSONTyped;
function ApiStoresUrlSlugAnalyticsProductsGet200ResponseToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'products': value.products === undefined ? undefined : (value.products.map(AnalyticsProductItem_1.AnalyticsProductItemToJSON)),
    };
}
exports.ApiStoresUrlSlugAnalyticsProductsGet200ResponseToJSON = ApiStoresUrlSlugAnalyticsProductsGet200ResponseToJSON;
